import React from "react";
import PropTypes from "prop-types";
import { compose } from "recompose";
import { Button } from "react-bootstrap";

import {
  Dialog as UIDialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from "../module";

const enhancer = compose();

Dialog.propTypes = {
  open: PropTypes.bool,
  onRequestClose: PropTypes.func,

  title: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  showCloseButton: PropTypes.bool,
  children: PropTypes.node.isRequired,
  position: PropTypes.string,
  alignActions: PropTypes.string
};

function Dialog(props) {
  return (
    <UIDialog open={props.open} position={props.position}>
      <DialogTitle
        title={props.title}
        onClose={props.showCloseButton ? props.onRequestClose : null}
      />

      <DialogContent>{props.children}</DialogContent>

      <DialogActions align={props.alignActions}>
        <Button onClick={props.onRequestClose}>Close</Button>
      </DialogActions>
    </UIDialog>
  );
}

export default enhancer(Dialog);



// WEBPACK FOOTER //
// ./src/components/Dialog.js